// tslint:disable
// @ts-ignore
import {
  Checkbox,
  Fab,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
  Typography
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { ExpandLess, ExpandMore, UnfoldMore, MoreVert, Clear } from "@material-ui/icons";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { IParticipant } from "src/common/types";
import { IOwnProps } from "./types";
import Loader from "../Loader";
import TableCheckbox from "./TableCheckbox";
import ParticipantActions from "./ParticipantActions";
type Entity = IParticipant | any;
const useStyles = makeStyles(theme => ({
  checkbox: {},
  checkboxCell: {
    width: "60px !important"
  },

  optionsWrapper: {
    display: "block" as "block",
    position: "relative" as "relative",
    "& button": {
      "&:active": {
        background: "transparent"
      }
    }
  },
  columnDataCell: {
    border: "none",
    padding: "0 6px",
    wordBreak: "break-word" as "break-word"
  },
  columnName: {
    display: "inline-block" as "inline-block",
    verticalAlign: "middle" as "middle",
    whiteSpace: "initial" as "initial"
  },
  container: {
    "& thead th": {
      background: "#ffffff",
      boxShadow: "0 1px 0 rgba(224, 224, 224, 1)",
      padding: "0 6px",
      position: "sticky" as "sticky",
      top: 0,
      zIndex: 1
    },
    "& thead tr + tr th": {
      top: 45
    },
    "& td": {
      width: "auto" as "auto",
      padding: "5px"
    },
    "& th": {
      cursor: "pointer",
      whiteSpace: "nowrap" as "nowrap",
      width: "auto" as "auto"
    },
    height: ({ customWidth }: any) => (customWidth ? customWidth : 650),
    maxHeight: ({ customWidth }: any) => (customWidth ? 320 : "auto"),
    minHeight: ({ customWidth }: any) => (customWidth ? 200 : "auto"),
    overflowY: "auto" as "auto"
  },
  fabButton: {
    background: "none" as "none",
    boxShadow: "none" as "none",
    position: "absolute" as "absolute",
    right: 20,
    top: -20,
    "&:disabled": {
      background: "transparent"
    }
  },
  headerIcon: {
    display: "inline-block",
    verticalAlign: "middle" as "middle"
  },
  hiddenDesktop: {
    display: "table-cell" as "table-cell",
    [theme.breakpoints.up("md")]: {
      display: "none" as "none"
    }
  },
  hiddenMobile: {
    display: "none" as "none",
    [theme.breakpoints.up("md")]: {
      display: "table-cell" as "table-cell"
    }
  },
  loading: {
    opacity: 0.54,
    pointerEvents: "none" as "none"
  },
  noCheckbox: {
    "& tr > td:first-child, & tr > th:first-child": {
      paddingLeft: 24
    }
  },
  noDataMsgContainer: {
    alignItems: "center",
    display: "flex",
    height: "100%",
    justifyContent: "center"
  },
  paginationActionsContainer: {
    marginLeft: "6px",
    [theme.breakpoints.up("md")]: {
      marginLeft: "20px"
    }
  },
  paginationSelect: {
    paddingRight: "24px"
  },
  paginationSelectContainer: {
    marginRight: "6px",
    [theme.breakpoints.up("md")]: {
      marginRight: "32px"
    }
  },
  selectAllCell: {
    background: "#ffffff",
    boxShadow: "0 1px 0 rgba(224, 224, 224, 1)",
    position: "sticky" as "sticky",
    top: 0
  },

  selectAllLabelCell: {
    padding: "0px 6px"
  },
  table: {
    tableLayout: "fixed" as "fixed"
  },
  tablePaginationCaption: {
    fontSize: "1rem",
    [theme.breakpoints.up("md")]: {
      fontSize: "1.4rem"
    }
  },
  tablePaginationRoot: {
    background: "#ffffff",
    bottom: 0,
    boxShadow: "0 -1px 0 rgba(224, 224, 224, 1)",
    position: "sticky" as "sticky",
    zIndex: 1
  },
  fab: {
    position: "relative" as "relative",
    display: "inline-block" as "inline-block",
    backgroundColor: "inherit" as "inherit",
    fontSize: "1.5em",
    minWidth: "140px",
    padding: "10px 5px",
    textAlign: "center" as "center"
  }
}));

const DataTable = ({
  showPagination,
  removeAction,
  actionsPerformedOn,
  cycleId,
  cancelReasons,
  loading = false,
  showCheckbox,
  tableConfig,
  onSortChange,
  onPageChange,
  onPageSizeChange,
  showParticipantsOnly,
  title,
  checkedEntities,
  refresh,
  onCheck,
  onDelete,
  onUncheck,
  onPageCheck,
  onPageUncheck,
  pageChecked,
  selectPageDisabled,
  enableMobile = false,
  entities,
  totalCount,
  page,
  pageSize,
  customWidth,
  handleReassign,
  handleTalkCancellation,
  handleTalkReopen
}: IOwnProps) => {
  const { t } = useTranslation();

  const classes = useStyles({
    customWidth
  });

  const getTableConfig = React.useCallback(() => {
    return {
      mobileColumns: enableMobile ? tableConfig.filter(({ hiddenMobile = true }) => !hiddenMobile) : [],
      desktopColumns: enableMobile ? tableConfig.filter(({ hiddenDesktop = true }) => !hiddenDesktop) : tableConfig
    };
  }, [tableConfig, enableMobile]);

  const { mobileColumns, desktopColumns } = getTableConfig();

  const [sortBy, setSortBy] = React.useState("firstName");
  const [sortOrder, setSortOrder] = React.useState<"ASC" | "DESC">("ASC");
  const [optionsOpen, updateOptionsOpen] = React.useState(null);

  const isRowSelected = React.useCallback(
    (rowData: any) => {
      if (checkedEntities) {
        return checkedEntities.includes(rowData.id);
      } else {
        return false;
      }
    },
    [checkedEntities]
  );

  const handleCheck = React.useCallback(
    (entity: Entity) => {
      return () => {
        onCheck && onCheck(entity);
      };
    },
    [onCheck]
  );

  const handleUncheck = React.useCallback(
    (entity: Entity) => {
      return () => onUncheck && onUncheck(entity);
    },
    [onUncheck]
  );

  const handleSelectPageClick = React.useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      if (e.currentTarget.checked) {
        onPageCheck && onPageCheck();
      } else {
        onPageUncheck && onPageUncheck();
      }
    },
    [onPageCheck, onPageUncheck]
  );

  const isSortActive = React.useCallback((columnName: string) => sortBy === columnName, [sortBy]);

  const handleSort = React.useCallback(
    (sortByColumn: string) => (event: React.MouseEvent) => {
      const newOrder = isSortActive(sortByColumn) && sortOrder === "ASC" ? "DESC" : "ASC";

      setSortBy(sortByColumn);
      setSortOrder(newOrder);
      if (onSortChange) {
        onSortChange({
          field: sortByColumn,
          order: newOrder
        });
      }
    },
    [isSortActive, sortOrder, setSortBy, setSortOrder, onSortChange]
  );

  const getSortIcon = React.useCallback(
    (columnName: string) => {
      if (isSortActive(columnName)) {
        if (sortOrder === "ASC") {
          return <ExpandLess className={classes.headerIcon} />;
        } else {
          return <ExpandMore className={classes.headerIcon} />;
        }
      }
      return <UnfoldMore className={classes.headerIcon} />;
    },
    [isSortActive, sortOrder]
  );

  const handleChangePage = React.useCallback(
    (_event: any, newPage: number) => {
      if (onPageChange) {
        onPageChange(newPage);
      }
    },
    [onPageChange]
  );

  const handleChangeRowsPerPage = React.useCallback(
    (event: any) => {
      const newSize = parseInt(event.target.value, 10);
      if (onPageSizeChange) {
        onPageSizeChange(newSize);
      }
    },
    [onPageSizeChange]
  );

  const renderFromTo = React.useCallback(
    ({ from, to, count }) => t(`feedback.dataTable.fromTo`, { from, to, count }),
    [t]
  );

  const handleOptionsClose = React.useCallback(() => {
    updateOptionsOpen(null);
  }, []);

  const handleOptionsOpen = React.useCallback(id => {
    updateOptionsOpen(id);
  }, []);

  const tableClassNames = [classes.table];

  const containerClassNames = (loading ? [classes.container, classes.loading] : [classes.container]).join(" ");

  if (!showCheckbox) {
    tableClassNames.push(classes.noCheckbox);
  }

  const hasActionBeenPerformed = (id: string) => actionsPerformedOn.includes(id);

  return (
    <div className={containerClassNames}>
      {entities && totalCount > 0 ? (
        <Table className={tableClassNames.join(" ")}>
          <TableHead>
            {title ? <h3 style={{ whiteSpace: "nowrap", paddingLeft: "1.2rem" }}>{title}</h3> : null}

            <TableRow>
              {showCheckbox && (
                <TableCell className={classes.checkboxCell} data-qa-selector={`userName-checkbox`}>
                  <Checkbox
                    disabled={selectPageDisabled}
                    checked={pageChecked}
                    onChange={handleSelectPageClick}
                    data-qa-selector={`userName-checkbox`}
                  />
                </TableCell>
              )}
              {tableConfig.map(columnConfig => {
                const classNames = [
                  columnConfig.hiddenMobile && classes.hiddenMobile,
                  columnConfig.hiddenDesktop && classes.hiddenDesktop
                ]
                  .filter(className => className)
                  .join(" ");

                return (
                  <TableCell
                    key={columnConfig.columnName}
                    onClick={handleSort(columnConfig.sortColumn || columnConfig.columnName)}
                    className={classNames}
                    data-qa-selector={`header-${columnConfig.columnName}`}
                  >
                    <Typography display="inline" variant="body2">
                      <span className={classes.columnName}>{t(`feedback.dataTable.${columnConfig.columnName}`)}</span>
                    </Typography>
                    {showParticipantsOnly &&
                    (columnConfig.columnName === "tenure" || columnConfig.columnName === "directSupervisorEmail")
                      ? null
                      : getSortIcon(columnConfig.sortColumn || columnConfig.columnName)}
                  </TableCell>
                );
              })}
              <TableCell />
            </TableRow>
          </TableHead>

          <TableBody>
            {entities.map((rowData, index) => {
              const rowSelected = isRowSelected(rowData);
              const isItemSelected = rowData.isIncluded || rowSelected;
              const background = isItemSelected ? "rgb(240, 240, 240)" : "";
              return (
                <TableRow hover style={{ backgroundColor: background }} key={rowData.id}>
                  {showCheckbox && (
                    <TableCell className={[classes.columnDataCell, classes.checkboxCell].join(" ")}>
                      <TableCheckbox
                        refresh={refresh}
                        rowSelected={rowSelected}
                        isIncluded={rowData.isIncluded}
                        isChecked={isItemSelected}
                        data={rowData}
                        t={t}
                        testDataId={`userSelector-checkbox-${index}`}
                        handleUncheck={onUncheck}
                        handleCheck={onCheck}
                        onChange={rowSelected ? handleUncheck(rowData) : handleCheck(rowData)}
                        disabled={hasActionBeenPerformed(rowData.id)}
                      />
                    </TableCell>
                  )}
                  {tableConfig.map(columnConfig => {
                    const classNames = [
                      classes.columnDataCell,
                      columnConfig.hiddenMobile && classes.hiddenMobile,
                      columnConfig.hiddenDesktop && classes.hiddenDesktop
                    ]
                      .filter(className => className)
                      .join(" ");

                    return (
                      <TableCell
                        key={columnConfig.columnName}
                        className={classNames}
                        data-qa-selector={`${columnConfig.columnName}-cell-${index}`}
                      >
                        <Typography>
                          {columnConfig.mapContent
                            ? columnConfig.mapContent(rowData)
                            : rowData[columnConfig.columnName]}
                        </Typography>
                      </TableCell>
                    );
                  })}

                  <TableCell className={classes.columnDataCell}>
                    <div className={classes.optionsWrapper}>
                      {onDelete ? (
                        <Fab className={classes.fabButton} size="small" onClick={() => onDelete(rowData)}>
                          <Clear style={{ fontSize: 24, color: "gray" }} />
                        </Fab>
                      ) : (
                        <Fab
                          className={classes.fabButton}
                          size="small"
                          onClick={() => handleOptionsOpen(rowData.id)}
                          disabled={
                            !rowData.isIncluded ||
                            removeAction.includes(rowData.id) ||
                            hasActionBeenPerformed(rowData.id)
                          }
                        >
                          <MoreVert
                            data-qa-selector={`userSelector-options-${index}`}
                            color={
                              !rowData.isIncluded ||
                              removeAction.includes(rowData.id) ||
                              hasActionBeenPerformed(rowData.id)
                                ? "disabled"
                                : "primary"
                            }
                          />
                        </Fab>
                      )}

                      {optionsOpen === rowData.id && (
                        <ParticipantActions
                          id={rowData.id}
                          cycleId={cycleId}
                          cancelReasons={cancelReasons}
                          participant={rowData}
                          optionsOpen={optionsOpen}
                          handleOptionsClose={handleOptionsClose}
                          handleReassign={handleReassign}
                          talkStatus={rowData.talkStatus}
                          handleTalkCancellation={(body: { code: number; comment: string }) =>
                            handleTalkCancellation &&
                            handleTalkCancellation({
                              ...body,
                              participant: rowData
                            })
                          }
                          handleTalkReopen={() => handleTalkReopen && handleTalkReopen(rowData)}
                        />
                      )}
                    </div>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>

          <TableFooter>
            <TableRow>
              {showPagination === false ? null : (
                <TablePagination
                  colSpan={showCheckbox ? desktopColumns.length + 1 : desktopColumns.length}
                  classes={{
                    caption: classes.tablePaginationCaption,
                    root: enableMobile
                      ? [classes.tablePaginationRoot, classes.hiddenMobile].join(" ")
                      : classes.tablePaginationRoot,
                    select: classes.paginationSelect
                  }}
                  rowsPerPageOptions={[5, 10, 25, 50, 100, 500]}
                  count={totalCount}
                  rowsPerPage={pageSize}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  labelRowsPerPage={t(`feedback.dataTable.rowsPerPage`)}
                  labelDisplayedRows={renderFromTo}
                  SelectProps={{
                    native: true
                  }}
                />
              )}
              {showPagination === false ? null : enableMobile ? (
                <>
                  <TablePagination
                    colSpan={showCheckbox ? mobileColumns.length + 1 : mobileColumns.length}
                    classes={{
                      caption: classes.tablePaginationCaption,
                      root: [classes.tablePaginationRoot, classes.hiddenDesktop].join(" "),
                      select: classes.paginationSelect,
                      selectRoot: classes.paginationSelectContainer,
                      actions: classes.paginationActionsContainer
                    }}
                    rowsPerPageOptions={[5, 10, 25, 50, 100, 500]}
                    count={totalCount}
                    rowsPerPage={pageSize}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    labelRowsPerPage={t(`feedback.dataTable.rowsPerPage`)}
                    labelDisplayedRows={renderFromTo}
                    SelectProps={{
                      native: true
                    }}
                  />
                  <TableCell className={classes.tablePaginationRoot} />
                </>
              ) : null}
            </TableRow>
          </TableFooter>
        </Table>
      ) : loading ? (
        <Loader />
      ) : (
        <Grid item className={classes.noDataMsgContainer}>
          <Typography variant="h3">{t("feedback.page.cycle-participants.dataTable.noData")}</Typography>
        </Grid>
      )}
    </div>
  );
};

export default React.memo(DataTable);
